import { render, staticRenderFns } from "./SaleBackList.vue?vue&type=template&id=21840291&scoped=true"
import script from "./SaleBackList.vue?vue&type=script&lang=js"
export * from "./SaleBackList.vue?vue&type=script&lang=js"
import style0 from "./SaleBackList.vue?vue&type=style&index=0&id=21840291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21840291",
  null
  
)

export default component.exports